"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRuleSetInfo = void 0;

var _attributeSelectorUtils = require("./attributeSelectorUtils");

var _services = require("./services");

var PREFERRED_NUMBER_OF_VALUES = 10;

var isEmptyArray = function isEmptyArray(array) {
  return !(array && array.length);
};

var sort = function sort(values) {
  if (!isEmptyArray(values)) {
    var isNumber = !Number.isNaN(Number(values[0]));

    if (typeof values[0] === 'number' || isNumber) {
      values.sort(function (a, b) {
        return a - b;
      });
    } else {
      values.sort(function (a, b) {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
      });
    }
  }
};

var getDefaults = function getDefaults(values) {
  return values.length > PREFERRED_NUMBER_OF_VALUES ? values.slice(0, PREFERRED_NUMBER_OF_VALUES) : null;
};

var pushToDefaults = function pushToDefaults(defaults, number) {
  if (defaults.length < PREFERRED_NUMBER_OF_VALUES) {
    defaults.push(number);
  }
};

var getMoq = function getMoq(inputRanges) {
  var moq = null;

  if (!isEmptyArray(inputRanges)) {
    inputRanges.forEach(function (range) {
      moq = moq && moq < range.minimum ? moq : range.minimum;
    });
  }

  return moq;
};

var parseAttributes = function parseAttributes(name, inputValues, inputRanges, scope, allAttributeValues) {
  var lowerCaseName = name.toLowerCase(); // Value Attributes with more than 1 value

  if (!isEmptyArray(inputValues) && inputValues.length > 1) {
    var values = inputValues.map(function (value) {
      return value.value;
    });

    if (lowerCaseName === 'country') {
      values = values.map(function (countryCode) {
        return (0, _services.getCountryName)(countryCode);
      });
    }

    sort(values);
    var defaults = getDefaults(values);
    allAttributeValues[lowerCaseName] = {
      key: name,
      "class": scope,
      values: values,
      defaults: defaults
    };
  } else if (!isEmptyArray(inputRanges)) {
    var rangeFound = false;

    for (var i = 0; i < inputRanges.length; i += 1) {
      var range = inputRanges[i];

      if (range.increment) {
        rangeFound = true;
        break;
      } else if (range.minimum !== range.maximum) {
        inputRanges[i].increment = 1;
        rangeFound = true;
        break;
      }
    } // Ranged Attributes


    if (rangeFound) {
      var fixedValues = [];
      var ranges = [];
      var _defaults = [];
      var perRange = PREFERRED_NUMBER_OF_VALUES / inputRanges.length;
      perRange = perRange < 2 ? 2 : perRange;
      inputRanges.forEach(function (range) {
        var minimum = range.minimum,
            maximum = range.maximum;
        var increment = range.increment;
        increment = increment || 1;
        var currentAllocation = perRange;

        if (currentAllocation > 0 && !_defaults.includes(minimum)) {
          pushToDefaults(_defaults, minimum);
          currentAllocation -= 1;
        }

        if (maximum !== minimum) {
          if (maximum !== null) {
            ranges.push({
              minimum: minimum,
              maximum: maximum,
              increment: increment
            });

            if (currentAllocation > 0 && !_defaults.includes(maximum)) {
              pushToDefaults(_defaults, maximum);
              currentAllocation -= 1;
            }

            if (currentAllocation > 0) {
              var diff = (maximum - minimum) / perRange;
              var step = Math.round(diff / increment) * increment;
              var begin = minimum === 1 && step > 9 ? 0 : minimum;

              for (var _i = 1; _i <= currentAllocation; _i += 1) {
                var next = begin + _i * step;

                if (!_defaults.includes(next)) {
                  pushToDefaults(_defaults, next);
                }
              }
            }
          } else {
            ranges.push({
              minimum: minimum,
              maximum: 'infinity',
              increment: increment
            });

            var _begin = minimum === 1 ? 0 : minimum;

            var _step = increment;

            if (_step < 100 && 100 % _step === 0) {
              _step = 100;
              _begin = minimum < 100 ? 100 : minimum;
            }

            for (var _i2 = 1; _i2 <= currentAllocation; _i2 += 1) {
              var _next = _begin + _i2 * _step;

              if (!_defaults.includes(_next)) {
                pushToDefaults(_defaults, _next);
              }
            }
          }
        } else {
          fixedValues.push(minimum);
        }
      });

      if (_defaults.length > 0) {
        sort(_defaults);
      } // Set toolTip text


      var toolTip = null;

      if (fixedValues.length > 0) {
        sort(fixedValues);
        toolTip = "Must be ".concat(fixedValues.join(', '), "\n");
      }

      if (ranges.length > 0) {
        if (toolTip) {
          toolTip += 'or must be between\n';
        } else {
          toolTip = 'Must be between\n';
        }

        var rangeTexts = [];
        ranges = ranges.sort(function (a, b) {
          return a.minimum === b.minimum ? a.maximum - b.maximum : a.minimum - b.minimum;
        });
        ranges.forEach(function (range) {
          var minimum = range.minimum,
              maximum = range.maximum,
              increment = range.increment;
          rangeTexts.push("".concat(minimum, " and ").concat(maximum, " in increments of ").concat(increment));
        });
        toolTip += rangeTexts.join(',\n');
      }

      allAttributeValues[lowerCaseName] = {
        key: name,
        "class": scope,
        defaults: _defaults,
        isRange: true,
        values: {
          ranges: ranges,
          fixedValues: fixedValues
        },
        toolTip: toolTip
      };
    } // Ranged Attributes that are really value attributes (With more than 1 value)
    else if (inputRanges.length > 0) {
        var _values = inputRanges.map(function (range) {
          return range.minimum;
        });

        sort(_values);

        var _defaults2 = getDefaults(_values);

        allAttributeValues[lowerCaseName] = {
          key: name,
          "class": scope,
          values: _values,
          defaults: _defaults2
        };
      }
  }
};

var getRuleSetInfo = function getRuleSetInfo(ruleSet, requiredInputs) {
  if (!ruleSet || !requiredInputs) {
    return null;
  }

  var moq = null;
  var isQuantityDerived = false;
  var derivedAttributes = {};
  var allAttributeValues = {};
  var requiredAttributes = {};

  if (ruleSet) {
    requiredInputs = requiredInputs.filter(function (item) {
      var name = item.name;
      name = name.toLowerCase();
      var result = (0, _attributeSelectorUtils.findAttributeDependencies)(name, ruleSet);

      if (result && result.length > 1 && !derivedAttributes[name]) {
        derivedAttributes[name] = 1;
        result.forEach(function (value) {
          var lowerCaseValue = value.toLowerCase();

          if (lowerCaseValue !== name && !requiredAttributes[lowerCaseValue]) {
            requiredAttributes[lowerCaseValue] = 1;
          }
        });

        if (name === 'quantity') {
          isQuantityDerived = true;
          return true;
        }

        return false;
      }

      return true;
    });
  }

  if (ruleSet && !isEmptyArray(ruleSet.whiteList)) {
    ruleSet.whiteList.forEach(function (item) {
      var attributeKey = item.attributeKey,
          attributeValues = item.attributeValues,
          attributeRanges = item.attributeRanges;
      var lowerCaseName = attributeKey.toLowerCase();

      if (lowerCaseName === 'quantity') {
        moq = getMoq(attributeRanges);
      }

      if (!allAttributeValues[lowerCaseName] && requiredAttributes[lowerCaseName]) {
        parseAttributes(attributeKey, attributeValues, attributeRanges, item["class"], allAttributeValues);
      }
    });
  }

  if (!isEmptyArray(requiredInputs)) {
    requiredInputs.forEach(function (item) {
      var name = item.name,
          inputValues = item.inputValues,
          inputRanges = item.inputRanges,
          scope = item.scope;
      var lowerCaseName = name.toLowerCase();

      if (!moq && lowerCaseName === 'quantity') {
        moq = getMoq(inputRanges);
      }

      if (!allAttributeValues[lowerCaseName]) {
        parseAttributes(name, inputValues, inputRanges, scope, allAttributeValues);
      }
    });
  }

  requiredInputs.forEach(function (input) {
    var name = input.name,
        scope = input.scope;
    var inputValues = input.inputValues;
    var lowerCaseAttributeKey = name.toLowerCase();
    inputValues = inputValues.map(function (item) {
      return item.value;
    });

    if (!allAttributeValues[lowerCaseAttributeKey] && inputValues && inputValues.length > 1) {
      var defaults = getDefaults(inputValues);
      allAttributeValues[lowerCaseAttributeKey] = {
        key: name,
        "class": scope,
        values: inputValues,
        defaults: defaults
      };
    }
  });
  var quantityAttribute = allAttributeValues.quantity;

  if (isQuantityDerived) {
    delete allAttributeValues.quantity;
  }

  derivedAttributes = Object.keys(derivedAttributes);
  return {
    moq: moq,
    ruleSet: ruleSet,
    derivedAttributes: derivedAttributes,
    allAttributeValues: allAttributeValues,
    requiredInputs: requiredInputs,
    quantityAttribute: quantityAttribute
  };
};

exports.getRuleSetInfo = getRuleSetInfo;